module.exports = __webpack_public_path__ + "img/HAMAMATSU-icon.c7d12dd1.png";